import { Component, Input, OnInit } from '@angular/core';
import { Feature } from '..';

@Component({
    selector: 'app-feature-display',
    templateUrl: './feature-display.component.html',
    styleUrls: ['./feature-display.component.css'],
    standalone: false
})
export class FeatureDisplayComponent implements OnInit {

	datasource: Feature[];

	@Input() shortTermRentalId: number;
	@Input() developmentId: number;
	@Input() describesType: string;
	@Input() featureType: string;
	@Input() featuresList: Feature[] = [];
	@Input() title: string;

	feature: Feature;
	features: Feature[] = [];
	columns: any[];
	recordTotal: number;


	constructor() { }

	ngOnInit(): void {
	}
}
